<template>
  <div :class="classes">
        <pt-page-title title="商品二维码" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
          <el-button slot="before-left" type="primary" @click="createdQrCode">新建二维码</el-button>
      </pt-page-title>
      <pt-qr-code-table :tableLabels="tableLabels" :pageSize="pageSize" :paramsData="paramsData" ref="table">
          <template>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                  <el-button type="text" @click="deleteQrCode(scope.row)">删除</el-button>
                  <el-button type="text" @click="qrCodeDetail(scope.row)">详情</el-button>
                  <el-button type="text" @click="qrCodeDownload(scope.row)" v-if="scope.row.zipUrl">下载</el-button>
                  </template>
              </el-table-column>
          </template>
      </pt-qr-code-table>
    </div>
</template>

<script>
// 组件class前缀
import { qrCodeTableLabels } from './goods-qr-code-options.js'
import ptQrCodeTable from './pt-qr-code-table/withData.vue'
const prefixCls = 'pt-goods-qr-code'
export default {
  name: 'pt-goods-qr-code',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
      searchKey: null,
      tableLabels: qrCodeTableLabels,
      pageSize: 10,
      paramsData: {}
    }
  },
  components: {
    ptQrCodeTable
  },
  methods: {
    qrCodeDetail (row) {
      this.$router.push('/goods-qr-code-detail/' + row.id)
    },
    qrCodeDownload (row) {
    //   this.$emit('downloadQrCode', row.id)
      location.href = this.$publicResourcesUrlDownload + row.zipUrl
    },
    getTableData () {
      this.$refs.table.getTableData()
    },
    emptySearch () {
      this.searchKey = null
      this.$set(this.paramsData, 'searchKey', null)
    },
    search (val) {
      this.searchKey = val
      this.$set(this.paramsData, 'searchKey', val)
    },
    createdQrCode () {
      this.$router.push('/qr-code-form/fasle/0')
    },
    deleteQrCode (row) {
      this.$confirm('您确定删除该商品二维码吗', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(_ => {
        this.$emit('deleteQrCode', row.id)
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
